'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '../../../shared/cn';
export type ErrorMessageProps = {
  className?: string;
  children?: React.ReactNode;
};
export function ErrorMessage(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  if (!children) {
    return null;
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("text-base text-red-600 data-disabled:opacity-50 sm:text-sm dark:text-red-500", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <Headless.Description data-slot="error" {...props} className={t1}>{children}</Headless.Description>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}